export default __webpack_public_path__ + "static/media/three.69b8e7ba.jpg";